<style scoped>
.h-100 {
  height: 100%;
}
.min-h-100 {
  min-height: 100% !important;
}
.negativ-margin {
  margin-bottom: -20px;
}
</style>

<template>
  <div>
    <v-row no-gutters>
      <v-col class="font-weight-bold">
        {{ $t("PROGRAMME_DETAILS") }}
      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="(fun, i) in functionList" :key="i" cols="12" md="4">
        <v-card class="px-3 pb-3" outlined>
          <v-row class="text-right negativ-margin">
            <v-col :class="{ 'pa-0': functionList.length > 1 }">
              <v-btn
                v-show="functionList.length > 1"
                text
                fab
                x-small
                :ripple="false"
                @click="removeFunction(i)"
              >
                <v-icon>
                  {{ mdiWindowClose }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="fun.name"
                :label="$t('PROGRAMME_NAME') + '(#' + (i + 1) + ')'"
                :rules="rules.funtionNameRule"
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <AppDatePicker v-model="fun.date" :label="$t('DATE')" />
            </v-col>
            <v-col cols="12" md="6">
              <AppTimePicker v-model="fun.time" :label="$t('TIME')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <v-text-field
                v-model="fun.venue"
                :label="$t('VENUE')"
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="canAddMore && i === functionList.length - 1"
            class="pt-2 d-sm-none"
          >
            <v-col class="pl-0">
              <v-btn color="primary" text @click="addMoreEvent">
                <v-icon left>{{ mdiPlus }}</v-icon>
                {{ $t("ADD_MORE_PROGRAMME") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col
        v-if="canAddMore"
        cols="12"
        md="4"
        class="d-none d-sm-block min-h-100"
      >
        <v-card outlined class="px-3 pb-3 h-100" @click="addMoreEvent">
          <v-row class="h-100" align="center">
            <v-col cols="12" md="12" class="text-center primary--text">
              <v-icon color="primary">{{ mdiPlus }}</v-icon>
              <br />
              {{ $t("ADD_MORE_PROGRAMME") }}
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import messages from "../../app-js/messages.js";
import { mdiWindowClose, mdiPlus } from "@mdi/js";
import AppDatePicker from "@/components/AppDatePicker";
import AppTimePicker from "@/components/AppTimePicker";

export default {
  components: { AppDatePicker, AppTimePicker },

  props: {
    functionList: {
      type: Array,
      default: () => [{ name: "", venue: "", date: null, time: null }]
    },

    templateDetails: {
      type: Object,
      default: () => ({
        max_function_limit: 0
      })
    }
  },

  data() {
    return {
      mdiWindowClose,
      mdiPlus,
      rules: {
        funtionNameRule: [v => !!v || messages.PROGRAMME_NAME_ERROR],
        venueRule: [v => !!v || messages.PROGRAMME_VENUE_ERROR]
      }
    };
  },

  computed: {
    canAddMore() {
      return this.templateDetails.max_function_limit > this.functionList.length;
    }
  },

  methods: {
    addMoreEvent() {
      const event = { name: "", venue: "", date: null, time: null };
      this.functionList.push(event);
    },

    removeFunction(index) {
      this.functionList.splice(index, 1);
    }
  }
};
</script>
